var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":_vm.to}},[_c('inline-svg',{attrs:{"alt":_vm.$t('palavaLogoAlt'),"src":require('../assets/icons/palava.svg')}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }